import React, { createContext, useContext, useState, useEffect } from "react";
import { getCurrentUser } from "../api/auth";

export interface User {
  id: number;
  username: string;
  full_name: string;
  email: string;
}

interface UserContextType {
  user: User | null;
  setUser: React.Dispatch<React.SetStateAction<User | null>>;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      getCurrentUser().then(setUser).catch(() => setUser(null));
    }
  }, []);

  return (  
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) throw new Error("useUser должен использоваться внутри UserProvider");
  return { userId: context.user?.id, username: context.user?.username, setUser: context.setUser,  fullName: context.user?.full_name,Email: context.user?.email };
};
